import React from "react";
import { Routes, Route } from "react-router-dom";
import { publicRoutes, authProtectedRoutes } from "./allRoutes"; // Import the publicRoutes
import Layouts from "../Layouts/index";
import AuthProtected from "./AuthProtected";
import NonAuthLayout from "../Layouts/NonAuthLayout";
import RedirectLoggedIn from "./RedirectLoggedIn";

const Index = () => {
  return (
    <Routes>
      {/* Public routes */}
      {publicRoutes.map((route, idx) =>
        route?.path === "/login" ? (
          <Route
            path={route.path}
            element={
              <RedirectLoggedIn>
                <NonAuthLayout>{route.element}</NonAuthLayout>
              </RedirectLoggedIn>
            }
            key={idx}
            exact={true}
          />
        ) : (
          <Route path={route.path} element={route.element} key={idx} /> // Use route.element
        )
      )}

      {/* AuthProtected routes */}
      {authProtectedRoutes.map((route, idx) => (
        <Route
          path={route.path}
          element={
            <AuthProtected>
              <Layouts>{route.element}</Layouts>
            </AuthProtected>
          }
          key={idx}
          isAuthProtected={true}
        />
      ))}
    </Routes>
  );
};

export default Index;
